const productCollectionCard = document.querySelectorAll('.js-collection-card');

// Pre-order sizes ship later than the rest of the card. Each card publishes its own
// {variantId: "November 1"} map; they merge into one global so product-form.js can
// stamp the ship date onto the cart line when a card quick-adds.
window.RW_PREORDER = window.RW_PREORDER || {};

function rwApplyCardPreorder(elem) {
  const note = elem.querySelector('.js-card-preorder');
  const btn = elem.querySelector('.collection-card__quick-add .js-add-to-cart');
  if (!note || !btn) return;
  const copy = window.rwPreorderCopy(window.RW_PREORDER[btn.dataset.id]);
  const label = elem.querySelector('.js-cta-label');
  const soldOut = label && label.innerHTML.indexOf('Sold Out') !== -1;
  if (copy && !soldOut) {
    note.style.display = 'block';
    note.textContent = copy.card;
    if (label) label.innerHTML = copy.cta;
  } else {
    note.style.display = 'none';
    if (label && window.RW_PREORDER_CTAS.indexOf(label.innerHTML) !== -1) {
      label.innerHTML = 'Add to bag -';
    }
  }
}

productCollectionCard.forEach((elem) => {
  const raw = elem.getAttribute('data-preorder');
  if (!raw) return;
  try { Object.assign(window.RW_PREORDER, JSON.parse(raw)); } catch (e) {}
  rwApplyCardPreorder(elem);
});

productCollectionCard.forEach((elem, i) => {

  const handle = elem.getAttribute('data-product-form');

  fetch('/products/' + handle + '.js')
  .then(function(response) {
    response.json().then(data => {
      let product = data;
      let variants = product.variants;

      const cardRadio = elem.querySelectorAll('.js-radio-content');

      cardRadio.forEach((form, i) => {

        form.onchange = function () {
          const currentScent = elem.querySelector('.variant__name');

          const currentSize = elem.querySelector('.js-radio-content input:checked');
          const scentVal = currentScent ? currentScent.dataset.variant : undefined;

          variants.forEach((variant, i) => {
            const scentMatch = (scentVal === undefined || scentVal === '') ? true : variant.options.includes(scentVal);
            if(scentMatch && variant.options.includes(currentSize.value)) {

              let selectedVariantId = variant.id;
              let isAvailable = variant.available;

              const litSrc = currentSize ? currentSize.dataset.imageLit : '';
              const unlitSrc = currentSize ? currentSize.dataset.imageUnlit : '';
              const bgImg = elem.querySelector('.collection-card__img--bg img');
              const foreImg = elem.querySelector('.collection-card__img--fore img');
              if (bgImg && litSrc) { bgImg.removeAttribute('srcset'); bgImg.src = litSrc; }
              if (foreImg && unlitSrc) { foreImg.removeAttribute('srcset'); foreImg.src = unlitSrc; }

              elem.querySelector('.js-price').innerHTML = '$' + (variant.price/100);
              elem.querySelector('.product__link').href = product.url + '?variant=' + selectedVariantId;
              elem.querySelector('.collection-card__quick-add .js-add-to-cart').dataset.id = selectedVariantId;

              if(isAvailable) {
                console.log('available');
                elem.querySelector('.collection-card__quick-add .js-add-to-cart').disabled = false;
                elem.querySelector('.js-cta-label').innerHTML = 'Add to bag -';
                elem.querySelector('.js-price').innerHTML = '$' + (variant.price/100);
              } else {
                console.log('not available');
                elem.querySelector('.collection-card__quick-add .js-add-to-cart').disabled = true;
                elem.querySelector('.js-cta-label').innerHTML = 'Sold Out';
                elem.querySelector('.js-price').innerHTML = '';
              }

              rwApplyCardPreorder(elem);

            }
          });

        }
      });

    });
  })
  .catch(function(error) {
    console.log(error);
  });
});

